import { CheckCircle2 } from 'lucide-react'
import { formatOdds } from '@/lib/utils'
import type { MyBetSummary } from '@/types/miniApp'

const STATUS_LABEL: Record<string, string> = {
  PENDING: '',
  WON: ' · Ganada',
  LOST: ' · Perdida',
  VOID: ' · Void',
}

/** Fase R.12 (Bloque E, 17/08/2026): reemplaza al botón "LA JUGUÉ" cuando el usuario ya
 * registró esa apuesta -- nunca vuelve a ofrecer el botón (evita doble registro visual,
 * espejo del backend que ya es idempotente por índice único / chequeo explícito). */
export function PlayedBadge({ bet }: { bet: MyBetSummary }) {
  const profitLabel =
    bet.profit_loss != null
      ? `${bet.profit_loss >= 0 ? '+' : ''}${bet.profit_loss.toFixed(2)}€`
      : null

  return (
    <div className="w-full flex items-center justify-center gap-1.5 py-2 rounded-xl bg-brand-soft/20 border border-brand/30 text-brand text-[10px] font-black uppercase tracking-wider">
      <CheckCircle2 className="h-3.5 w-3.5" />
      JUGADA · {bet.stake.toFixed(2)}€ @{formatOdds(bet.played_odds)}
      {STATUS_LABEL[bet.status] ?? ''}
      {profitLabel && bet.status !== 'PENDING' && <span className="ml-1">({profitLabel})</span>}
    </div>
  )
}
